const getKey = ({ userId, word }) => `riddle_session:${userId}:${String(word || '').toLowerCase()}`;

export const loadRiddleSession = ({ userId, word }) => {
  if (!userId || !word) return { useCount: 0, riddles: [] };
  try {
    const raw = localStorage.getItem(getKey({ userId, word }));
    if (!raw) return { useCount: 0, riddles: [] };
    const parsed = JSON.parse(raw);
    const useCount = Number.isFinite(parsed?.useCount) ? parsed.useCount : 0;
    const riddles = Array.isArray(parsed?.riddles) ? parsed.riddles.filter(Boolean) : [];
    return { useCount, riddles };
  } catch {
    return { useCount: 0, riddles: [] };
  }
};

export const saveRiddleSession = ({ userId, word, useCount, riddles }) => {
  if (!userId || !word) return;
  try {
    const payload = {
      useCount: Number.isFinite(useCount) ? useCount : 0,
      riddles: Array.isArray(riddles) ? riddles : [],
      updatedAt: Date.now(),
    };
    localStorage.setItem(getKey({ userId, word }), JSON.stringify(payload));
  } catch {
    // ignore storage errors (quota, private mode, etc.)
  }
};

